var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGroupsBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.609 15.125C15.6692 15.125 18.15 12.6626 18.15 9.625C18.15 6.58743 15.6692 4.125 12.609 4.125C9.54872 4.125 7.0679 6.58743 7.0679 9.625C7.0679 12.6626 9.54872 15.125 12.609 15.125Z",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29739 28.875V26.125C4.29739 24.6663 4.88118 23.2674 5.92034 22.2359C6.95949 21.2045 8.36888 20.625 9.83846 20.625H15.3795C16.8491 20.625 18.2585 21.2045 19.2977 22.2359C20.3368 23.2674 20.9206 24.6663 20.9206 26.125V28.875",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3059 4.30371C23.4978 4.60662 24.5542 5.29467 25.3087 6.25939C26.0631 7.2241 26.4726 8.4106 26.4726 9.63184C26.4726 10.8531 26.0631 12.0396 25.3087 13.0043C24.5542 13.969 23.4978 14.657 22.3059 14.96",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2322 28.875V26.125C29.2252 24.9111 28.8137 23.7336 28.062 22.7761C27.3103 21.8186 26.2606 21.1348 25.0764 20.8313",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroupsBlue);
export default __webpack_public_path__ + "static/media/Icon_Groups_Blue.43cceb49148d53862c6c51e9763a2017.svg";
export { ForwardRef as ReactComponent };